import { X as attr_class, a2 as stringify, Y as attr, Q as slot, S as bind_props, a1 as sanitize_props } from "./index2.js";
function Link($$renderer, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  $$renderer.component(($$renderer2) => {
    let to = $$props["to"];
    $$renderer2.push(`<a${attr_class(`group text-md flex items-center font-display font-medium !text-inherit hover:opacity-70 no-underline transition-all cursor-pointer ${stringify($$sanitized_props.class)} gap-2`)}${attr("href", to)}><!--[-->`);
    slot($$renderer2, $$props, "default", {});
    $$renderer2.push(`<!--]--> <i class="material-symbols-outlined !text-sm !font-bold pointer-events-none -translate-x-1 group-hover:translate-x-0 relative flex items-center justify-center w-4 h-[24px] !leading-[24px] transition-transform"><span class="opacity-100 group-hover:opacity-0 absolute">keyboard_arrow_right</span> <span class="opacity-0 group-hover:opacity-100 absolute">arrow_right_alt</span></i></a>`);
    bind_props($$props, { to });
  });
}
export {
  Link as L
};
